const simpleListToArr = (list) => {
  const arr = list.split(',');
  if (arr.length < 1) {
    return [];
  }
  return arr.map((classname) => {
    return classname.trim();
  });
}

export {
  simpleListToArr
};